import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ChevronButtonSC } from './chevron-button.styled';

interface IChevronButtonProps {
  textId: string;
  goForth?: () => void;
  className?: string;
}

const ChevronButton: React.FC<IChevronButtonProps> = ({ textId, goForth, className }) => (
  <ChevronButtonSC onClick={goForth} className={className} rightArrow>
    <FormattedMessage id={textId} />
  </ChevronButtonSC>
);

export default ChevronButton;
